import api, { createDecoder, noContentDecoder } from "../../api";
import { DriverUndispatchedCargos, driverUndispatchedCargosT } from "./types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loadRouteWithStops } from "../route-with-stops";

type State = {
  requestState: "idle" | "loading" | "success" | "error";
  data: DriverUndispatchedCargos;
};

const initialState: State = {
  requestState: "idle",
  data: [],
};

const prefix = "data/undispatched-cargos";

export const loadUndispatchedCargos = createAsyncThunk(
  `${prefix}/load-undispatched-cargos`,
  async (_, thunkAPI) =>
    api(thunkAPI).get({
      url: `/drivers-api/cargos/undispatched`,
      decoder: createDecoder(driverUndispatchedCargosT),
    })
);

export const moveUndispatchedCargoToRoute = createAsyncThunk(
  `${prefix}/add-undispatched-cargo-to-route`,
  async (
    { cargoId, routeId }: { cargoId: string; routeId: string | null },
    thunkAPI
  ) => {
    await api(thunkAPI).post({
      url: `/drivers-api/cargos/${cargoId}/move-to-route`,
      body: { routeId },
      decoder: noContentDecoder,
    });
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(moveUndispatchedCargoToRoute.fulfilled, (state, action) => {
      state.data = state.data.filter((c) => c.id !== action.meta.arg.cargoId);
    });
    builder.addCase(loadUndispatchedCargos.pending, (state) => {
      state.requestState = "loading";
    });
    builder.addCase(loadUndispatchedCargos.fulfilled, (state, action) => {
      state.requestState = "success";
      state.data = action.payload;
    });
    builder.addCase(loadUndispatchedCargos.rejected, (state) => {
      state.requestState = "error";
    });
  },
});

export default slice.reducer;
